import { InputAdornment, TextField } from "@mui/material";
import React, { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import classNames from "classnames";

interface SearchFieldProps {
  placeholder?: string;
  disabled?: boolean;
  onSearch?: (searchValue?: string) => void;
}

const SearchField = (props: SearchFieldProps) => {
  const { placeholder, disabled, onSearch } = props;

  const [currentValue, setCurrentValue] = useState<string>("");

  const handleSearchInput = (value?: string) => {
    setCurrentValue(value ?? "");
    if (onSearch !== undefined) {
      onSearch(value);
    }
  };

  const className = classNames("dui-search", {
    "dui-search-disabled": disabled,
  });

  return (
    <div className={className}>
      <TextField
        className="dui-search-field"
        placeholder={placeholder}
        disabled={disabled}
        onChange={(e) => {
          handleSearchInput(e.target.value);
        }}
        value={currentValue}
        InputProps={{
          className: "dui-search-field-inner",
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon className="dui-icon" />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <ClearIcon
                className="dui-icon dui-icon-clear"
                onClick={() => {
                  handleSearchInput("");
                }}
              />
            </InputAdornment>
          ),
        }}
        variant="standard"
      />
    </div>
  );
};

export default SearchField;
